import React, { Component } from 'react';
import { filterImageBasedOnImageCode } from '../../../utils/FilterImages';
import './index.scss';
import { ReactComponent as InSeatDeliveryIcon } from '../../../assets/images/in-seat-delivery-icon.svg';
import { ReactComponent as PickupAtCounterIcon } from '../../../assets/images/to-be-picked-up-icon.svg';

export default class FnbItemCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: props.item,
      itemIndex: props.itemIndex,
      tabId: props.tabId,
    };
  }

  getLowestPriceFromAlternateItems = alternateItems => {
    var allPricesArray = [];
    alternateItems.map(alternateItem => {
      var altItemPrice = alternateItem.strikeValueBeforeTax == null ? alternateItem.valuebeforetax : alternateItem.strikeValueBeforeTax;
      allPricesArray.push(altItemPrice);
    });
    const min = Math.min(...allPricesArray);
    return min.toFixed(2);
  };
  handleDeliveryTypeUI = item => {
    const params = new URLSearchParams(window.location.search);
    let cinemaId = params.get('cinemaid');
    let showDeliveryTypeForAllLocations = window.constant.SHOW_DELIVERY_TYPE.ALL_LOCATIONS;
    let deliveryTypeActiveLocations = window.constant.SHOW_DELIVERY_TYPE.ACTIVE_LOCATIONS;
    if (showDeliveryTypeForAllLocations || (cinemaId && deliveryTypeActiveLocations.includes(cinemaId))) {
      return (
        <div className={`fnb-item-card-delivery-type ${item.pickupAtCounter ? 'to-be-picked-up' : item.inSeatDelivery ? 'in-seat-delivery' : ''}`}>
          {item.pickupAtCounter ? (
            <>
              <PickupAtCounterIcon />
              <p>To be picked up</p>
            </>
          ) : item.inSeatDelivery ? (
            <>
              <InSeatDeliveryIcon /> <p>Delivered to your seat</p>{' '}
            </>
          ) : (
            'No delivery'
          )}
        </div>
      );
    }
  };

  render() {
    let { item, itemIndex, tabId } = this.state;
    return (
      <div
        key={itemIndex}
        className={`fnb-item-card ${item.active && item.show ? '' : 'unavailableItem'} ${item.disableVoucherItem ? 'disableItem' : ''}`}
        style={{ order: this.props.sort }}
        onClick={() => {
          if (item.active && item.show) {
            // // // this.props.addToCartButtonClick(itemIndex, tabId);
            this.props.addToCartButtonClick(itemIndex, tabId, item);
          }
        }}
      >
        <div className="fnb-item-card-inner">
          {this.handleDeliveryTypeUI(item)}
          <div className="item-image-container">
            <img src={filterImageBasedOnImageCode(item.fnbs_images, 'x325y185')} alt={item.name} className="item-image" />
          </div>
          <div className="item-details">
            <div>
              <h3>{item.itemName}</h3>
              {item.itemDetails.length != 0 ? <p className="itemDetails">{item.itemDetails}</p> : <></>}
            </div>

            <div
              // className="item-price-cart"
              className={`item-price-cart ${window.constant.ENABLE_VOUCHERS === 'true' && item.voucherCodes && item.voucherCodes.length > 0 ? 'noStrikeprice' : ''}`}
            >
              {window.constant.ENABLE_VOUCHERS === 'true' && item.voucherCodes && item.voucherCodes.length > 1 && item.maximumqty > 1 ? (
                <aside className="vouchersAppliedDetails">
                  <p>{item.totalItemsAdded && item.totalItemsAdded > 0 ? `${item.totalItemsAdded} of ${item.maximumqty} used` : `${item.maximumqty} Available`}</p>
                </aside>
              ) : (
                ''
              )}
              <div>
                {item.fnbs_alternateitems.length != 0 ? (
                  this.getLowestPriceFromAlternateItems(item.fnbs_alternateitems) != '0.00' ? (
                    <>
                      <div className="item-price strikePrice noLinethrough">
                        <span className="currency">Starts from</span>
                      </div>
                      <div className="item-price">
                        <span className="currency">$</span>
                        {this.getLowestPriceFromAlternateItems(item.fnbs_alternateitems)}
                      </div>
                    </>
                  ) : (
                    <></>
                  )
                ) : item.strikeValueBeforeTax == null ? (
                  item.valuebeforetax == 0 || item.valuebeforetax == '0' ? (
                    <></>
                  ) : (
                    <div className="item-price">
                      <span className="currency">$</span>
                      {item.valuebeforetax.toFixed(2)}
                    </div>
                  )
                ) : (
                  <>
                    <div className="item-price strikePrice">
                      <span className="currency">$</span>
                      {item.valuebeforetax.toFixed(2)}
                    </div>
                    <div className="item-price">
                      <span className="currency">$</span>
                      {item.strikeValueBeforeTax.toFixed(2)}
                    </div>
                  </>
                )}
              </div>

              {item.active && item.show ? (
                // // // <button className="add-to-cart" onClick={() => this.props.addToCartButtonClick(itemIndex, tabId)}>
                <button className="add-to-cart" onClick={() => this.props.addToCartButtonClick(itemIndex, tabId, item)}>
                  + ADD
                </button>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="addedOverlay">{item.hasOwnProperty('voucherCodes') && item.totalItemsAdded === 0 ? '' : <p>ADDED</p>}</div>
        </div>
      </div>
    );
  }
}
